export const RingSizeGroup = {
  SMALL: '6-8',
  MEDIUM: '9-10',
  LARGE: '11-13',
} as const;
